import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatSelectModule } from '@angular/material/select'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { SelectAllOptionComponent } from '../select-all-option'
import { FacilitySelectorFieldComponent } from './facility-selector.component'

@NgModule({
  imports: [
    SelectAllOptionComponent,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
  declarations: [
    FacilitySelectorFieldComponent,
  ],
  exports: [
    FacilitySelectorFieldComponent,
  ],
})
export class FacilitySelectorModule {}
